import { createContext } from 'react';

export interface CaptureInfo {
  displaySurface: string;
  width: number;
  height: number;
  isCapturingWindowOrMonitor: boolean;
}

export interface ScreenRecorderContextType {
  isScreenSharingActive: boolean;
  screenStream: MediaStream | null;
  captureInfo: CaptureInfo | null;
  acquireScreenStream: () => Promise<void>;
  startScreenRecording: (audioStream?: MediaStream) => void;
  stopScreenRecording: () => Promise<void>;
  setChunkHandler: (handler: ((chunk: Blob) => void) | undefined) => void;
  captureFrame: () => Promise<string | null>;
}

export const ScreenRecorderContext =
  createContext<ScreenRecorderContextType | null>(null);
